import type { ReactNode } from 'react'

import { cases } from '@subaio/utils'
import { BrandLogo } from '@subaio/webapp'

import { Logo } from 'components/Logo'

import { AlignmentWrapper } from './AlignmentWrapper'
import { Background } from './Background'
import { Container } from './Container'
import { Content } from './Content'
import { Title } from './Title'
import { TopWrapper } from './TopWrapper'

type Props = {
	title: ReactNode
	brandId: string | null
}

export const Header = ({ title, brandId }: Props) => (
	<Container>
		<TopWrapper>
			<Content>
				<AlignmentWrapper gridArea='logo' align='left'>
					<Logo />
				</AlignmentWrapper>
				<AlignmentWrapper gridArea='brand' align='center'>
					{brandId &&
						cases(brandId, {
							nordeabudget_internal_dk: <span>INTERN</span>,
							nordeabudget_subaio_dk: <BrandLogo brandId={brandId} size={52} />,
						})}
				</AlignmentWrapper>
			</Content>
		</TopWrapper>
		<Title>{title}</Title>
		<Background />
	</Container>
)
